<template>
  <div class="sources-select-field">
    <v-autocomplete
      :value="value"
      :items="items"
      attach
      chips
      deletable-chips
      small-chips
      :label="label"
      :hint="hint"
      persistent-hint
      outlined
      multiple
      item-text="name"
      item-value="id"
      :loading="loading"
      :disabled="loading"
      @input="syncValue"
    >
    </v-autocomplete>
  </div>
</template>

<script>
  import _ from 'lodash'
  import { mapGetters } from 'vuex'
  import rules from '@/mixins/rules'
  import OrganizationDataService from '@/services/api/OrganizationDataService'
  import FilialDataService from '@/services/api/FilialDataService'
  import SourceDataService from '@/services/api/SourceDataService'

  export default {
    name: 'SourcesSelectField',
    components: { },
    mixins: [rules],
    props: {
      items: {
        type: Array,
        default: () => [],
      },
      label: {
        type: String,
        default: 'Блюдо доступно в источниках',
      },
      value: {
        type: Array,
        default: () => [],
      },
      hint: {
        type: String,
        default: null,
      },
      loading: Boolean,
      disabled: Boolean,
    },
    data () {
      return {

      }
    },
    computed: {

    },
    methods: {
      syncValue (value) {
        this.search = ''
        this.$emit('input', value)
      },
    },
  }
</script>

<style lang="less" scoped>
.sources-select-field {
  ::v-deep {
    .v-text-field {
      .v-label--active {
        transform: translateY(-25px) scale(0.75);
      }

    }

  }

}

.sources-select-field_search {
  margin-top: -5px;
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 10;

  ::v-deep {
    .v-list-item__content {
      padding-bottom: 0;
    }

    .v-label:not(.v-label--active) {
      top: 0;
    }

  }
}
</style>
